import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import spineManager from "slotworks/graphics/spine/spine-manager";
import Point from "slotworks/utils/geom/point";
import SpineSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/spine-symbol-behaviour";


export default class LeprechaunSymbolBehaviour extends SpineSymbolBehaviour {

    protected animate(animation: string, autoReset: boolean = false, loop: boolean = false) {

        // Resolve existing animations before starting a new one
        if (this.completeResolve) {
            this.completeResolve();
        }
        this.cleanUp();

        const spine = spineManager.createSpineSymbol(this.symbol.symbolId);

        if(!spine) {
            return Contract.empty();
        }

        this.spine = spine;

        this.spine.setSkin("base");

        const masterRect = Layers.MatrixContent.getPosition(this.masterSymbol);

        let animRect = Layers.MatrixContent.getPosition(this.symbol.symbolId + "_spine");

        if(animRect) {
            this.offset = new Point(
                animRect.x + animRect.width/2 - masterRect.x - masterRect.width/2,
                animRect.y + animRect.height/2 - masterRect.y - masterRect.height/2
            );
        } else {
            this.offset = new Point(0, 0);
        }
        
        if (!spine.state.hasAnimation(animation)) {
            return Contract.empty();
        }
        
        Layers.SymbolAnimations.container.addChild(spine as any);

        this.symbol.setVisible(false);

        this.updateTransform();

        return new Contract<void>((resolve) => {
            this.completeResolve = () => resolve(null);

            spine.state.setAnimation(0, animation, loop);

            if(!loop) {
                spine.state.tracks[0].listener = {
                    complete: () => {
                        setTimeout(() => {
                            this.cleanSpine();

                            if (this.completeResolve) {
                                this.completeResolve();
                                this.completeResolve = null;
                            }
                        }, 1);
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/matrix/leprechaun-symbol-behaviour.ts